const storagePrefix = 'mc-mos_';

// Текущая локаль
export const LOCAL_STORAGE_LOCALE = `${storagePrefix}locale` as const;

export const LOCAL_STORAGE_KEYS = [LOCAL_STORAGE_LOCALE];
export type LocalStorageKeys = typeof LOCAL_STORAGE_KEYS[number];
